import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "browser-url-bar level is-mobile" }

import RefreshIcon from 'vue-material-design-icons/Refresh.vue';
import { useVModel } from '@vueuse/core';


export default /*@__PURE__*/_defineComponent({
  __name: 'BrowserUrlBar',
  props: {
  modelValue: {
    type: String,
    required: true,
  },
},
  emits: ["update:modelValue", "refreshClicked"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
const url = useVModel(props, 'modelValue', emit);

function refreshButtonClicked() {
  emit('refreshClicked');
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_text_input = _resolveComponent("n-text-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_n_button, {
      variant: "ghost",
      onClick: refreshButtonClicked,
      class: "refresh-button level-item is-narrow"
    }, {
      default: _withCtx(() => [
        _createVNode(RefreshIcon, { class: "icon-1-3x" })
      ]),
      _: 1
    }),
    _createVNode(_component_n_text_input, {
      modelValue: _unref(url),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(url) ? (url).value = $event : null)),
      "hide-label": "",
      label: "Current URL",
      class: "level-item"
    }, null, 8, ["modelValue"])
  ]))
}
}

})